<template>
  <div class="intelligentAgriculture-page">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <!-- <h2 style="font-size: 46px;font-weight: 500;position: absolute;color: #fff;left: 15%;top: 240px;text-shadow: 3px 3px 3px #2c3e50;">高标准农田建设方案</h2>
                <h2 style="font-size: 32px;font-weight: 500;position: absolute;color: #fff;left: 15%;top: 320px;">High standard farmland construction scheme</h2> -->
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/fishAndVeg/banner.webp">            
            </div>

          <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">鱼菜共生—生态循环技术</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">养鱼产生的排泄物，通过硝化菌转化为养分给植物吸收，吸收干净的水体又流回鱼池养鱼。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/fishAndVeg/index01.webp">                                             
                    </div>
                </div>    
            </div> 
             <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">鱼菜共生—碳中和技术</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">通过鱼菜共生生态循环系统及大棚内植物过滤，到达大棚内co2循环利用，对外零排放的目的。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/fishAndVeg/index02.webp">                                             
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">鱼菜共生—示范区平面图</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">鱼菜共生种养殖示范区规划样例。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/fishAndVeg/index03.webp">                                             
                    </div>
                </div>    
            </div>  
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">鱼菜共生—生态调节系统</h2>
                    <div>
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/fishAndVeg/index04.webp">                                             
                    </div>
                </div>    
            </div>  
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">鱼菜共生项目实施案例</h2>
                    <div>   
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/fishAndVeg/index05.webp">                                             
                    </div>
                </div>    
            </div>          
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        select:1,
    }
  },
  mounted() {
  },
  methods: {
      clicknav(e){
          this.select = e
      }
  }
}
</script>
<style>
    .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
     .list-box p{
        margin-bottom: 14px;
    }
    .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
    .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
    .three-box{
        width: 30%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        height: 430px;
        margin: 1.6%;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }c

    .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
    .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
    .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
    .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
        .left-cbox{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 34px;
    }
    .right-box{
        float: left;
        width: 50%;
            padding: 25px;
    background: #FFFFFF;
    box-shadow: 0px 0px 31px 1px rgba(14, 5, 10, 0.04);
    height: 248px;
       
    }
    .right-box  h3{
        width: 100%;
            margin-bottom: 20px;
        }
        .fourbox{
            float: left;
            width: 21%;
            margin: 2%;
            background: #fff;
            border: 1px solid #1AB334;
            box-sizing: border-box;
            padding: 10px;
            height: 220px;
        }
        .fourbox img {
            margin: auto;
        }
         .fourbox p {
            margin: 20px 0;
        }
        .top-right{
            right: 63px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 94px;
        }
        .bottom-left{
                left: 81px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 274px;
        }
</style>